module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "border-radius": "16px"
    }
  }, [_c('div', {
    staticClass: "media-list"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/audioResources'
      }
    }
  }, [_vm._v("音频资源上传")]), _vm._v(" "), _vm._l((_vm.albumLevel), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      class: (_vm.albumLevel.length - 1) == index ? '' : 'backLevel',
      staticStyle: {
        "cursor": "pointer",
        "font-weight": "bold"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.backLevel(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tableList"
  }, [_c('el-form', {
    staticClass: "searchForm",
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formResource
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "批量上传音频"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload_file",
    attrs: {
      "action": "/aries-api/resource/upload",
      "before-upload": _vm.onBeforeAudioUpload,
      "on-success": _vm.onSuccessAudioUpload,
      "on-error": _vm.onError,
      "on-remove": _vm.handleRemove,
      "show-upload-list": false,
      "data": _vm.uploadData,
      "on-change": _vm.handleChange,
      "multiple": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n            上传音频资源\n            "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), _c('el-form-item', [(_vm.albumLevel.length < 4) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createFolder
    }
  }, [_vm._v("\n          创建文件夹\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.albumData.length != 0),
      expression: "albumData.length != 0"
    }],
    staticStyle: {
      "width": "700px"
    },
    attrs: {
      "data": _vm.albumData,
      "row-key": _vm.refresh
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "100",
      "label": "序号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "justify-content": "space-around",
            "align-items": "center"
          }
        }, [_c('b', [_vm._v(_vm._s(scope.$index + 1))]), _vm._v(" "), (scope.row.albumType == 'folder') ? _c('img', {
          attrs: {
            "src": require("../../assets/folder.png"),
            "alt": "",
            "width": "40"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.albumType == 'audio') ? _c('img', {
          attrs: {
            "src": require("../../assets/audio.png"),
            "alt": "",
            "width": "40"
          }
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "文件名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.albumType == 'folder' && scope.row.changeName) ? _c('el-input', {
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.albumType == 'folder' && !scope.row.changeName) ? _c('span', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.editChildSong(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))]) : _vm._e(), _vm._v(" "), (scope.row.albumType == 'audio' || !scope.row.albumType) ? _c('span', [_vm._v(_vm._s(scope.row.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "状态",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.albumType == 'audio' || !scope.row.albumType) ? _c('Progress', {
          attrs: {
            "percent": _vm.audioUploadPercent,
            "status": _vm.audioUploadStatus
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "280",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.albumType == 'audio' && _vm.currentAudioIndex !== scope.$index && (scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) == 'tpm' || scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) == 'mp3' || scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) == 'TPM' || scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) == 'MP3')) ? _c('i', {
          staticClass: "el-icon-video-play",
          staticStyle: {
            "font-size": "20px",
            "margin-right": "10px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.onPlayTTS(scope.row, scope.$index)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.albumType == 'audio' && _vm.currentAudioIndex == scope.$index && (scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) == 'tpm' || scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) == 'mp3' || scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) == 'TPM' || scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) == 'MP3')) ? _c('i', {
          staticClass: "el-icon-video-pause",
          staticStyle: {
            "font-size": "20px",
            "margin-right": "10px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.onPauseTTS(scope.row, scope.$index)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) !== 'tpm' && scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) !== 'mp3' && scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) !== 'TPM' && scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1) !== 'MP3') ? _c('span', {
          staticStyle: {
            "margin-right": "35px"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "id": 'audio' + scope.$index
          }
        }, [_c('audio')]), _vm._v(" "), (scope.row.albumType == 'audio' || !scope.row.albumType) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "重命名",
            "placement": "top-start"
          }
        }, [(scope.row.albumType == 'folder' && scope.row.id && !scope.row.changeName) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.reAlbumName(scope.$index, scope.row)
            }
          }
        }, [_vm._v("重命名")]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "保存",
            "placement": "top-start"
          }
        }, [(scope.row.albumType == 'folder' && scope.row.changeName) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.creatChildSong(scope.$index, scope.row)
            }
          }
        }, [_vm._v("√")]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "编辑",
            "placement": "top-start"
          }
        }, [(scope.row.albumType == 'folder' && scope.row.id && !scope.row.changeName) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editChildSong(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "删除",
            "placement": "top-start"
          }
        }, [(scope.row.albumType == 'folder' && !scope.row.changeName) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteChildSong(scope.$index, scope.row)
            }
          }
        }, [_vm._v("×")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.sortShow) ? _c('div', [_c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排序方式:"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radioTo),
      callback: function($$v) {
        _vm.radioTo = $$v
      },
      expression: "radioTo"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "90%",
      "color": "black"
    }
  }, [_vm._v("资源上传正序")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radioTo),
      callback: function($$v) {
        _vm.radioTo = $$v
      },
      expression: "radioTo"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "90%",
      "color": "black"
    }
  }, [_vm._v("资源名称正序")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.radioTo),
      callback: function($$v) {
        _vm.radioTo = $$v
      },
      expression: "radioTo"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "90%",
      "color": "black"
    }
  }, [_vm._v("资源上传倒序")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.radioTo),
      callback: function($$v) {
        _vm.radioTo = $$v
      },
      expression: "radioTo"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "90%",
      "color": "black"
    }
  }, [_vm._v("资源名称倒序")])]), _vm._v(" "), _c('p', [_vm._v("可拖拽手动进行排序")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "position": "relative",
      "bottom": "15px"
    }
  }, [_vm._v("文件夹和音频混排时，文件夹排在音频前面")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "45%",
      "margin-top": "30px",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loadingBtn
    },
    on: {
      "click": function($event) {
        return _vm.commitAudio('')
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "padding-left": "20px",
      "font-size": "13px",
      "position": "relative",
      "bottom": "18px",
      "color": "rgb(144, 147, 153)"
    }
  }, [_vm._v("\n      注:"), _c('span', {
    staticStyle: {
      "margin-left": "4px"
    }
  }, [_vm._v("1.一个系列，音频+文件夹最多可上传300个 ")]), _c('br'), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("2.付费音频请上传.mp3格式，硬件设备下载音频后会做加密保护\n      ")]), _vm._v(" "), _c('br'), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("3.听力熊T3，T4系列不支持多层专辑显示\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c04363c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/addAlbums.vue
// module id = 701
// module chunks = 1